import React, { useEffect, useRef } from 'react';

interface LazyImageProps {
    src: string;
    alt: string;
    className: string;
    placeholderClassName: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({ src, alt, className, placeholderClassName }) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const imageRef = useRef<HTMLImageElement>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        observerRef.current = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !isLoaded) {
                        setIsLoaded(true);
                        if (observerRef.current && imageRef.current) {
                            observerRef.current.unobserve(imageRef.current);
                        }
                    }
                });
            },
            { rootMargin: '50px' }
        );

        if (imageRef.current) {
            observerRef.current.observe(imageRef.current);
        }

        return () => {
            if (observerRef.current && imageRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                observerRef.current.unobserve(imageRef.current);
                observerRef.current.disconnect();
            }
        };
    }, [isLoaded]);

    return (
        <>
            {isLoaded ? (
                <img
                    ref={imageRef}
                    src={src}
                    alt={alt}
                    className={className}
                    loading="lazy"
                />
            ) : (
                <div ref={imageRef} className={`${className} ${placeholderClassName}`} />
            )}
        </>
    );
};